import addUrlParams from "./addUrlParams";
import getUmbracoEndPoint from "./UmbracoEndPoint";

export default (request: string, params?: { [name: string]: string }): URL => {
    let baseURL: string;
    let url: URL;

    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
        baseURL = "https://backend.rekomgroup.com/";
    }
    else {
        baseURL = getUmbracoEndPoint() + "/";
    }

    if (request && request.startsWith("http")) {
        url = new URL(request);
    }

    url = new URL(request, baseURL);

    if (params) {
        url = addUrlParams(url, params);
    }

    return url;
};
